let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
import { P, match } from 'ts-pattern';
import styled, { css, keyframes } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
import Box from '../Box';
import { fontStack } from '../styles';
function parseDimension(dimension) {
  return typeof dimension === 'number' ? `${dimension}px` : dimension;
}
const gradientKeyframe = keyframes(_t || (_t = _`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`));
export const StyledSkeleton = styled(Box)(_t2 || (_t2 = _`
    width: 96px;
    height: 96px;

    &:before {
        display: block;

        width: 100%;

        background: linear-gradient(
            90deg,
            ${0} 0%,
            ${0} 39.5%,
            ${0} 67.81%,
            ${0} 100%
        );
        background-size: 200% 200%;

        border-radius: 8px;

        animation: ${0} 3.5s ease-in-out infinite;

        content: '';
    }

    ${0};
`), colors.skeletonGradient1, colors.skeletonGradient2, colors.skeletonGradient2, colors.skeletonGradient1, gradientKeyframe, props => match(props).with({
  variant: 'circle'
}, ({
  $height: height
}) => css(_t3 || (_t3 = _`
                    width: ${0};
                    height: ${0};

                    &:before {
                        height: 100%;

                        border-radius: 50%;
                    }
                `), parseDimension(height), parseDimension(height))).with({
  variant: P.union('rect', 'block'),
  // @ts-ignore
  $height: P.union(...Object.keys(fontStack))
},
// @ts-ignore
({
  $width: width,
  $height: height
}) => {
  const size = fontStack[height].fontSize;
  const indent = fontStack[height].lineHeight;
  return css(_t4 || (_t4 = _`
                        width: ${0};
                        height: ${0};

                        &:before {
                            position: relative;
                            top: calc((${0} - ${0}) / 2);

                            height: ${0};
                        }
                    `), parseDimension(width), indent, indent, size, size);
}).with({
  variant: P.union('rect', 'block')
}, ({
  $width: width,
  $height: height
}) => css(_t5 || (_t5 = _`
                    width: ${0};
                    height: ${0};

                    &:before {
                        height: 100%;
                    }
                `), parseDimension(width), parseDimension(height))).run());